import CreationTool from 'creation/src/creation-tools/types/creation-tool'
import CreationToolGradient from './gradient'

const gradients: Record<CreationTool, CreationToolGradient> = {
    [CreationTool.SuperCut]: CreationToolGradient.BlackBlack,
    [CreationTool.GifMaker]: CreationToolGradient.PinkIndigo,
    [CreationTool.Upload]: CreationToolGradient.IndigoBlue,
}

const peekerUrls: Record<CreationTool, string> = {
    [CreationTool.GifMaker]: '/static/img/creation_tools/gif-maker-peeker.gif',
    [CreationTool.Upload]: '/static/img/creation_tools/upload-peeker.gif',
    [CreationTool.SuperCut]: '/static/img/creation_tools/supercut-peeker.gif',
}

const backgroundVideoUrls: Record<CreationTool, string> = {
    [CreationTool.GifMaker]: '/static/img/videos/9rv8tcpftaJcBDLamd.mp4',
    [CreationTool.Upload]: '/static/img/videos/forest-still.mp4',
    [CreationTool.SuperCut]: '/static/img/videos/gachapon.mp4',
}

/**
 * Returns the tool's gradient colors.
 */
export const creationToolGradient = (tool: CreationTool): CreationToolGradient => gradients[tool]

/**
 * Returns the tool's welcome screen peeker sticker url.
 */
export const creationToolPeekerUrl = (tool: CreationTool): string => peekerUrls[tool]

/**
 * Returns the tool's welcome screen background video url.
 */
export const creationToolBackgroundVideoUrl = (tool: CreationTool): string => backgroundVideoUrls[tool]

export default CreationTool
